import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { X, Loader2, Gift as GiftIcon } from "lucide-react";

export default function GiftPicker({ recipientName, onClose, onSend, sending }) {
  const [gifts, setGifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/gifts/catalog")
      .then(({ data }) => setGifts(data.gifts || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="absolute inset-0 z-[70] flex flex-col justify-end" data-testid="gift-picker">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => !sending && onClose?.()} />
      <div className="relative bg-[#15121E] border-t border-white/10 rounded-t-3xl p-6 pb-8 animate-float-up max-h-[80%] overflow-y-auto no-scrollbar">
        <div className="flex items-center gap-2 mb-1">
          <GiftIcon className="w-5 h-5 text-rose-400" />
          <h3 className="text-lg font-bold text-white" style={{ fontFamily: "Outfit, sans-serif" }}>Send a gift</h3>
          <button data-testid="gift-picker-close" onClick={() => !sending && onClose?.()} className="ml-auto w-8 h-8 grid place-items-center text-slate-400 rounded-full active:bg-white/10"><X className="w-5 h-5" /></button>
        </div>
        <p className="text-sm text-slate-400 mb-4">Surprise {recipientName || "them"} — the amount is deducted from your wallet balance.</p>

        {loading ? (
          <div className="py-10 grid place-items-center"><Loader2 className="w-6 h-6 text-rose-500 animate-spin" /></div>
        ) : (
          <div className="grid grid-cols-4 gap-2.5 mb-5">
            {gifts.map((g) => (
              <button key={g.id} data-testid={`gift-option-${g.id}`} onClick={() => setSelected(g)}
                className={`flex flex-col items-center justify-center gap-1 py-3 rounded-2xl border transition-colors ${selected?.id === g.id ? "bg-rose-500/20 border-rose-500" : "bg-white/5 border-white/10"}`}>
                <span className="text-2xl leading-none">{g.emoji}</span>
                <span className="text-[11px] font-bold text-white">₹{g.price}</span>
              </button>
            ))}
          </div>
        )}

        <button data-testid="gift-send-button" disabled={!selected || sending} onClick={() => selected && onSend(selected)}
          className="w-full h-12 rounded-2xl bg-gradient-to-r from-[#FF2E63] to-[#FF6B8B] text-white font-bold active:scale-[0.98] transition-transform disabled:opacity-50 flex items-center justify-center gap-2">
          {sending ? <><Loader2 className="w-5 h-5 animate-spin" /> Sending…</>
            : selected ? <>Send {selected.emoji} {selected.label} · ₹{selected.price}</>
            : "Select a gift"}
        </button>
      </div>
    </div>
  );
}
